/* eslint-disable react-refresh/only-export-components */
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"
import type { ComponentProps } from "react"
import { cn } from "cn"

const headingVariants = cva("text-labels-primary", {
  variants: {
    size: {
      // 24/32px – Tailwinds `text-2xl` trifft die Figma-Werte exakt.
      lg: "text-2xl",
      // 20/28px – Tailwinds `text-xl` trifft die Figma-Werte exakt.
      md: "text-xl",
    },
    weight: {
      // Figma-Style „Bold" mit Gewicht 650 – zwischen Tailwinds `font-semibold`
      // (600) und `font-bold` (700), daher als Arbitrary Value übernommen.
      bold: "font-[650]",
    },
  },
  defaultVariants: {
    size: "md",
    weight: "bold",
  },
})

export type HeadingSize = NonNullable<
  VariantProps<typeof headingVariants>["size"]
>

export type HeadingWeight = NonNullable<
  VariantProps<typeof headingVariants>["weight"]
>

export type HeadingProps = ComponentProps<"h2"> &
  VariantProps<typeof headingVariants> & {
    asChild?: boolean
  }

function Heading({
  className,
  size = "md",
  weight = "bold",
  asChild = false,
  ...props
}: HeadingProps) {
  const Comp = asChild ? Slot.Root : "h2"

  return (
    <Comp
      data-slot="heading"
      data-size={size}
      data-weight={weight}
      className={cn(headingVariants({ size, weight, className }))}
      {...props}
    />
  )
}

export { Heading, headingVariants }
